import { Navigate, Outlet } from 'react-router-dom';

import { useSession } from '@/components/auth/user-provider';

/**
 * Route guard for the internal Partner Engagement area: signed-in customer-role users (Entra
 * guests) are redirected to their portal. Staff and local-dev sessions pass
 * through; signed-out users are handled by the AppShell sign-in screen.
 */
export function RequireStaff() {
  const { session } = useSession();

  if (session.status === 'signedIn' && session.user.role === 'customer') {
    return <Navigate to="/portal" replace />;
  }

  return <Outlet />;
}
